import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ page, pages, onPage }) {
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-center gap-2 mt-12">
      <button onClick={() => onPage(page - 1)} disabled={page === 1}
        className="p-2 border border-dark-600 text-ink-400 hover:border-gold hover:text-gold disabled:opacity-30 transition-colors">
        <ChevronLeft size={16} />
      </button>
      {Array.from({ length: pages }, (_, i) => i + 1).map(p => (
        <button key={p} onClick={() => onPage(p)}
          className={`w-9 h-9 text-xs font-medium border transition-colors ${p === page ? 'border-gold bg-gold text-white' : 'border-dark-600 text-ink-400 hover:border-gold hover:text-gold'}`}>
          {p}
        </button>
      ))}
      <button onClick={() => onPage(page + 1)} disabled={page === pages}
        className="p-2 border border-dark-600 text-ink-400 hover:border-gold hover:text-gold disabled:opacity-30 transition-colors">
        <ChevronRight size={16} />
      </button>
    </div>
  );
}
